/**
 * DTO enum for setting types returned by the API
 * Represents all possible settings pages available in the system
 */
export enum SettingTypeDTO {
  USER_PROFILE = 'USER_PROFILE',
  USER_PASSWORD = 'USER_PASSWORD',
  ORGANIZATION_DEPARTMENTS = 'ORGANIZATION_DEPARTMENTS',
  ORGANIZATION_SENIORITIES = 'ORGANIZATION_SENIORITIES',
  ORGANIZATION_ROLES = 'ORGANIZATION_ROLES',
  ORGANIZATION_GENERAL_SETTINGS = 'ORGANIZATION_GENERAL_SETTINGS',
  ORGANIZATION_EXTERNAL_RATES = 'ORGANIZATION_EXTERNAL_RATES',
  ORGANIZATION_TIME_OFF = 'ORGANIZATION_TIME_OFF',
  ORGANIZATION_PERMISSIONS = 'ORGANIZATION_PERMISSIONS',
  ORGANIZATION_INTEGRATION = 'ORGANIZATION_INTEGRATION',
  ORGANIZATION_API = 'ORGANIZATION_API',
  ORGANIZATION_PROJECT_CUSTOM_ATTRIBUTES = 'ORGANIZATION_PROJECT_CUSTOM_ATTRIBUTES',
  ORGANIZATION_TAGS = 'ORGANIZATION_TAGS',
  ORGANIZATION_MEMBERS_ACCESS = 'ORGANIZATION_MEMBERS_ACCESS',
}

/**
 * Type alias for setting type in API responses
 */
export type SettingTypeResponse = SettingTypeDTO;
